import React, {useEffect, useState} from 'react'
import Select from 'react-select'
import {
  WorkOrderStatusQueryParams,
  WorkOrderStatusClient,
} from '../../../infrastracture/api/WorkOrderStatusClient'
import customStyles from './customStyles'

interface Props {
  name?: string
  defaultValue?: any
  placeholder?: string
  disabled?: boolean
  onChange?: (name: any, value: any, label?: any) => void
  excludeStatusFlowId?: string
  statusFlowId?: string
}

const WorkOrderStatusSelector: React.FC<Props> = (props: any) => {
  const {defaultValue, placeholder, disabled, name, onChange, excludeStatusFlowId, statusFlowId} =
    props

  const [options, setOptions] = useState([])
  const [value, setValue] = useState<any>({})

  const defaultId = 'workOrderStatusId'

  useEffect(() => {
    populateData()
  }, [])

  useEffect(() => {
    if (statusFlowId) populateData()
  }, [statusFlowId])

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const populateData = async () => {
    var query = new WorkOrderStatusQueryParams()

    if (excludeStatusFlowId) query.WithExcludeStatusFlowId(excludeStatusFlowId)

    if (statusFlowId) query.WithStatusFlowId(statusFlowId)

    var data = (
      await WorkOrderStatusClient.List(
        query.Paginate(0, 10000).WithActive(true).Sort('name', 'asc')
      )
    ).data

    if (data) {
      setOptions(
        data.data.map((item: any) => {
          return {
            value: item.id,
            label: item.name,
          }
        })
      )
    }
  }

  const handleChange = (values: any) => {
    const {value, label} = values
    setValue(values)
    onChange(defaultId, value, label)
  }

  return (
    <Select
      onChange={handleChange}
      value={value}
      options={options}
      placeholder={placeholder}
      isDisabled={disabled}
      id={name ? name : defaultId}
      name={name ? name : defaultId}
      styles={customStyles}
      menuPortalTarget={document.body}
    />
  )
}

export default WorkOrderStatusSelector
